const style = theme => ({
  iframe: {
    border: 0,
    height: 1500,
  },
})

export default style
